<template>

    <div>
        <div class="modal fade" id="taskFormModal" tabindex="-1" role="dialog">
            <div :class="{'modal-dialog':true,'modal-lg':!editing || !canEditFinance,'modal-xl':editing && canEditFinance}" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Taak {{ editing ? lang.get("global.edit") : lang.get("global.add") }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div :class="{'col-lg-9':editing && canEditFinance,'col-lg-12':!editing || !canEditFinance}">
                                <div class="form-horizontal">
                                    <div class="row">
                                        <div class="col-md-6 col-lg-4">
                                            <label class="control-label col-xl-3">Zelf invoeren:</label>
                                            <div class="col-xl-9" v-if="tasktypes.length > 0">
                                                <bootstrap-toggle
                                                    v-model="task.owntext"
                                                    :options="{ on: 'Ja', off: 'Nee' }"
                                                    :disabled="false"
                                                />
                                            </div>
                                            <div class="col-xl-9" v-else>Ja</div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="control-label col-xl-5">{{ lang.get("tasks.contractfee") }}:</label>
                                                <div class="col-xl-7">
                                                    <money
                                                        v-model="task.fee"
                                                        v-bind="getMoneySettings"
                                                        :disabled="!canEditFinance"
                                                        class="form-control"
                                                    ></money>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="control-label col-xl-5">{{ lang.get("global.startdate") }}:</label>
                                                <div class="col-xl-7">
                                                    <date-picker
                                                        v-model="task.startdate"
                                                        format="DD-MM-YYYY"
                                                        lang="en"
                                                    ></date-picker>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="control-label col-xl-3">{{ lang.get("tasks.task") }}:</label>
                                                <div class="col-xl-9">
                                                    <v-select
                                                        v-if="task.owntext === false && tasktypes.length > 0"
                                                        v-model="task.tasktype"
                                                        :options="tasktypes"
                                                    ></v-select>
                                                    <input
                                                        v-else
                                                        type="text"
                                                        class="form-control"
                                                        v-model="task.text" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="control-label col-xl-5">{{ lang.get("tasks.expenses") }}:</label>
                                                <div class="col-xl-7">
                                                    <money
                                                        v-model="task.expenses"
                                                        v-bind="getMoneySettings"
                                                        :disabled="!canEditFinance"
                                                        class="form-control"
                                                    ></money>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="control-label col-xl-5">{{ lang.get("global.enddate") }}:</label>
                                                <div class="col-xl-7">
                                                    <date-picker
                                                        v-model="task.enddate"
                                                        format="DD-MM-YYYY"
                                                        lang="en"
                                                    ></date-picker>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="control-label col-xl-3">{{ lang.get("global.active") }}:</label>
                                                <div class="col-xl-9">
                                                    <bootstrap-toggle
                                                        v-model="task.active"
                                                        :options="{ on: 'Ja', off: 'Nee' }"
                                                        :disabled="false"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="control-label col-xl-5">{{ lang.get("tasks.reserved") }}:</label>
                                                <div class="col-xl-7">
                                                    <money
                                                        v-model="task.reserved"
                                                        v-bind="getMoneySettings"
                                                        :disabled="!canEditFinance"
                                                        class="form-control"
                                                    ></money>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="control-label col-xl-5">{{ lang.get("tasks.targetbudget") }}:</label>
                                                <div class="col-xl-7">
                                                    <money
                                                        :value="calcTargetBudget | toCurrency"
                                                        disabled
                                                        v-bind="getMoneySettings"
                                                        class="form-control disabled"
                                                    ></money>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">{{ lang.get("global.description") }}</label>
                                    <editor
                                        v-model="task.description"
                                        ref="editor"
                                    ></editor>
                                </div>
                            </div>
                            <div class="col-lg-3" v-if="editing && canEditFinance">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{{ lang.get("tasks.selectcostcodes") }}</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="selectedCostcodes.length === 0"><td colspan="2">{{ lang.get("tasks.noselectedcostcodes") }}</td></tr>
                                        <tr v-for="cc in selectedCostcodes">
                                            <td>{{ cc.label }}</td>
                                            <td class="text-right"><button class="btn btn-xs btn-danger" type="button" @click="removeCostcode(cc)"><i class="fa fa-times"></i></button></td>
                                        </tr>
                                    </tbody>
                                    <tfoot v-if="getCostcodes.length > 0">
                                        <tr>
                                            <td colspan="2">
                                                <v-select v-model="selectedCostcode" :options="getNonSelectedCostcodes"></v-select>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="canEditFinance">
                        <div class="modal-body" v-if="editing">
                            <div class="nav-tabs-custom">
                                <ul class="nav nav-tabs">
                                    <li :class="{'active':section === 'salesinvoices'}"><a href="javascript:void(0);" @click="section = 'salesinvoices'">Verkoopfacturen</a></li>
                                    <li :class="{'active':section === 'purchaseinvoices'}"><a href="javascript:void(0);" @click="section = 'purchaseinvoices'">Inkoopfacturen</a></li>
                                    <li :class="{'active':section === 'usergrouprates'}"><a href="javascript:void(0);" @click="section = 'usergrouprates'">Uurtarieven</a></li>
                                    <li :class="{'active':section === 'defaultsettings'}"><a href="javascript:void(0);" @click="section = 'defaultsettings'">Standaard instellingen</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="modal-body" v-if="editing && section === 'salesinvoices'">
                            <div class="row">
                                <div class="col-xl-9">
                                    <h4>{{ lang.get("tasks.salesinvoices.name") }}</h4>
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th>{{ lang.get("tasks.expected") }}</th>
                                                <th>{{ lang.get("tasks.send") }}</th>
                                                <th>{{ lang.get("tasks.paid") }}</th>
                                                <th>{{ lang.get("global.contact") }}</th>
                                                <th>{{ lang.get("tasks.term") }}</th>
                                                <th>{{ lang.get("tasks.po_number") }}</th>
                                                <th class="text-right">{{ lang.get("tasks.expenses") }}</th>
                                                <th class="text-right">{{ lang.get("tasks.sum") }}</th>
                                                <th class="text-right">{{ lang.get("global.total") }}</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="salesinvoices.length === 0">
                                                <td colspan="11">{{ lang.get("tasks.salesinvoices.none") }}</td>
                                            </tr>
                                            <tr v-for="si in salesinvoices" :id="'si-' + si.uuid">
                                                <td v-if="si.creator" :title="si.creator.fullname">{{ si.creator.code }}</td>
                                                <td v-else>&nbsp;</td>
                                                <td v-if="si.send !== true">
                                                    <update-expected
                                                        v-model="si.expected_at"
                                                        :update-url="si.paths.updateExpected"
                                                    ></update-expected>
                                                </td>
                                                <td v-else>{{ moment(si.expected_at).format("DD-MM-YYYY") }}</td>
                                                <td>{{ si.send === true ? moment(si.send_at).format("DD-MM-YYYY") : 'Nee' }}</td>
                                                <td>{{ si.paid === true ? moment(si.paid_at).format("DD-MM-YYYY") : 'Nee' }}</td>
                                                <td>{{ si.contact ? si.contact.fullname : '' }}</td>
                                                <td>{{ si.paymentterm }} {{ lang.get("global.days") }}</td>
                                                <td>{{ si.po_number }}</td>
                                                <td v-if="!si.send">
                                                    <update-expenses
                                                        v-model="si.expenses"
                                                        :update-url="si.paths.updateExpenses"
                                                        @valueUpdated="adjustSubTotal($event, 'expenses', si)"
                                                    ></update-expenses>
                                                </td>
                                                <td v-else>
                                                    {{ si.expenses | toCurrency }}
                                                </td>
                                                <td v-if="!si.send">
                                                    <update-amount
                                                        v-model="si.amount"
                                                        :update-url="si.paths.updateAmount"
                                                        @valueUpdated="adjustSubTotal($event, 'amount', si)"
                                                    ></update-amount>
                                                </td>
                                                <td v-else>
                                                    {{ si.amount | toCurrency }}
                                                </td>
                                                <td class="text-right">{{ si.sub_total | toCurrency }}</td>
                                                <td class="text-right">
                                                    <div v-if="si.send !== true && si.created !== true" class="btn-group btn-group-xs">
                                                        <delete-button
                                                            :parent-element="'si-' + si.uuid"
                                                            :url="getInvoiceDeleteUri(si)"
                                                            title="Verkoopfactuur"
                                                            :name="'verkoopfactuur verwacht op ' + moment(si.expected_at).format('DD-MM-YYYY')"
                                                        ></delete-button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="9" class="text-right font-weight-bold">{{ lang.get("global.total") }}:</td>
                                                <td class="text-right font-weight-bold">{{ getSalesInvoicesTotal | toCurrency }}</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td colspan="9" class="text-right font-weight-bold">Nog te factureren:</td>
                                                <td :class="{'text-right font-weight-bold':true,'text-danger':getSalesInvoiceRemaining < 0}">{{ getSalesInvoiceRemaining | toCurrency }}</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="col-xl-3">
                                    <h4>{{ lang.get("tasks.salesinvoices.add") }}</h4>
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("global.contact") }}</label>
                                            <div class="col-md-9">
                                                <div class="input-group">
                                                    <input type="text" disabled class="form-control" :value="getSalesinvoiceContact">
                                                    <div class="input-group-btn">
                                                        <button class="btn btn-sm btn-default" @click="searchContact('invoice')"><i class="mdi mdi-account-search"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("tasks.expected") }}</label>
                                            <div class="col-md-9">
                                                <date-picker v-model="salesinvoice.expecteddate" format="DD-MM-YYYY" lang="en"></date-picker>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3 text-right">{{ lang.get("tasks.sum") }}</label>
                                            <div class="col-md-9">
                                                <money v-model="salesinvoice.amount" v-bind="getMoneySettings" class="form-control"></money>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("tasks.expenses") }}</label>
                                            <div class="col-md-9">
                                                <money v-model="salesinvoice.expenses" v-bind="getMoneySettings" class="form-control"></money>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("tasks.po_number") }}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="salesinvoice.po_number" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("tasks.term") }}</label>
                                            <div class="col-md-9">
                                                <div class="input-group">
                                                    <input type="number" class="form-control" v-model="salesinvoice.paymentterm" />
                                                    <span class="input-group-addon">
                                                    {{ lang.get("global.days") }}
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("tasks.period") }}</label>
                                            <div class="col-md-9">
                                                <div class="input-group">
                                                    <input type="number" class="form-control" v-model="salesinvoice.nrmonths" />
                                                    <span class="input-group-addon">
                                                    {{ lang.get("global.months") }}
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="col-md-12 text-right">
                                                <button
                                                    :class="{'btn btn-success':true,'disabled':!canSaveSalesInvoice}"
                                                    :disabled="!canSaveSalesInvoice"
                                                    type="button"
                                                    @click="saveSalesInvoice()"
                                                >
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body" v-if="editing && section === 'purchaseinvoices'">
                            <div class="row">
                                <div class="col-xl-9">
                                    <h4>{{ lang.get("tasks.purchaseinvoices.name") }}</h4>
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th>{{ lang.get("global.description") }}</th>
                                                <th>{{ lang.get("tasks.expected") }}</th>
                                                <th>{{ lang.get("tasks.paid") }}</th>
                                                <th>{{ lang.get("global.contact") }}</th>
                                                <th class="text-right">{{ lang.get("tasks.expense") }}</th>
                                                <th class="text-right">{{ lang.get("tasks.sum") }}</th>
                                                <th class="text-right">{{ lang.get("global.total") }}</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="purchaseinvoices.length === 0">
                                                <td colspan="10">{{ lang.get("tasks.purchaseinvoices.none") }}</td>
                                            </tr>
                                            <tr v-for="pi in purchaseinvoices" :id="'pi-' + pi.uuid">
                                                <td :title="pi.creator.fullname">{{ pi.creator.code }}</td>
                                                <td>{{ pi.description }}</td>

                                                <td v-if="pi.send !== true">
                                                    <update-expected
                                                        v-model="pi.expected_at"
                                                        :update-url="pi.paths.updateExpected"
                                                    ></update-expected>
                                                </td>
                                                <td v-else>{{ moment(pi.expected_at).format("DD-MM-YYYY") }}</td>
                                                <td>{{ pi.paid === true ? moment(pi.paid_at).format("DD-MM-YYYY") : 'Nee' }}</td>
                                                <td>{{ pi.contact ? pi.contact.fullname : '' }}</td>
                                                <td class="text-right">{{ pi.expenses | toCurrency }}</td>
                                                <td class="text-right">{{ pi.amount | toCurrency }}</td>
                                                <td class="text-right">{{ pi.sub_total | toCurrency }}</td>
                                                <td class="text-right">
                                                    <div v-if="pi.send !== true" class="btn-group btn-group-xs">
                                                        <delete-button
                                                            :parent-element="'pi-' + pi.uuid"
                                                            :url="getInvoiceDeleteUri(pi)"
                                                            title="Inkoopfactuur"
                                                            :name="'inkoopfactuur verwacht op ' + moment(pi.expected_at).format('DD-MM-YYYY')"
                                                        ></delete-button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="8" class="text-right">{{ lang.get("global.total") }}:</td>
                                                <td class="text-right">{{ getPurchaseInvoicesTotal | toCurrency }}</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="col-xl-3">
                                    <h4>{{ lang.get("tasks.purchaseinvoices.add") }}</h4>
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("global.contact") }}</label>
                                            <div class="col-md-9">
                                                <div class="input-group">
                                                    <input type="text" disabled class="form-control" :value="getPurchaseinvoiceContact">
                                                    <div class="input-group-btn">
                                                        <button class="btn btn-default btn-sm" @click="searchContact('purchase')"><i class="mdi mdi-account-search"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("global.description") }}</label>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="purchaseinvoice.description" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("tasks.expected") }}</label>
                                            <div class="col-md-9">
                                                <date-picker v-model="purchaseinvoice.expecteddate" format="DD-MM-YYYY" lang="en"></date-picker>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("tasks.sum") }}</label>
                                            <div class="col-md-9">
                                                <money v-model="purchaseinvoice.amount" v-bind="getMoneySettings" class="form-control"></money>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-3">{{ lang.get("tasks.expenses") }}</label>
                                            <div class="col-md-9">
                                                <money v-model="purchaseinvoice.expenses" v-bind="getMoneySettings" class="form-control"></money>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="col-md-12 text-right">
                                                <button :class="{'btn btn-success':true,'disabled':!canSavePurchaseInvoice}" :disabled="!canSavePurchaseInvoice" type="button" @click="savePurchaseInvoice()"><i class="fa fa-plus"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body" v-if="editing && section === 'usergrouprates'">
                            <div class="row">
                                <div class="col-xl-9">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Groep</th>
                                                <th>Standaard Uurtarief</th>
                                                <th>Taak Uurtarief</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="getUsergroupData.length === 0">
                                                <td colspan="3">Er zijn geen afwijkende uurtarieven beschikbaar binnen deze taak</td>
                                            </tr>
                                            <tr v-for="usergroupRate in getUsergroupData">
                                                <td v-text="usergroupRate.name"></td>
                                                <td>{{ usergroupRate.origrate | toCurrency }} <span v-if="usergroupRate.ratedate">({{ usergroupRate.ratedate }})</span></td>
                                                <td>{{ usergroupRate.rate | toCurrency }}</td>
                                                <td class='text-right'>
                                                    <button v-if="usergroupRate.paths" class="btn btn-danger btn-xs" @click="deleteUsergroupRate(usergroupRate)">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-xl-3">
                                    <h4>Afwijkend uurtarief toevoegen</h4>
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label col-xl-4">Gebruikersgroep</label>
                                            <div class="col-md-8">
                                                <v-select v-model="usergroupForm.usergroup_id" :options="getAvailableUsergroups" label="name"></v-select>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-xl-4">Uurtarief</label>
                                            <div class="col-md-8">
                                                <money v-model="usergroupForm.rate" v-bind="getMoneySettings" class="form-control"></money>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="col-md-12 text-right">
                                                <button :class="{'btn btn-success':true,'disabled':!canAddUsergroupRate}" :disabled="!canAddUsergroupRate" type="button" @click="addUsergroupRate()"><i class="fa fa-plus"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body" v-if="editing && section === 'defaultsettings'">
                            <div class="form-horizontal">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label col-xl-5">{{ lang.get("tasks.defaultterm") }}</label>
                                            <div class="col-xl-7">
                                                <div class="input-group">
                                                    <input type="number" class="form-control" v-model="task.paymentterm" />
                                                    <span class="input-group-addon">
                                                    {{ lang.get("global.days") }}
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label col-xl-5">{{ lang.get("tasks.po_number") }}</label>
                                            <div class="col-xl-7">
                                                <input type="text" class="form-control" v-model="task.po_number" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer text-right">
                        <button
                            class="btn btn-primary"
                            :disabled="!canSubmit"
                            @click="onSubmit()"
                        >{{ editing ? lang.get("global.edit") : lang.get("global.add") }}</button>
                    </div>
                </div>
            </div>
        </div>
        <crm-selector
            :on-selected="selectContact"
        ></crm-selector>
    </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { Money } from 'v-money';
import axios from 'axios';
import Hub from '../../../Hub';
import Lang from '../../../Lang';
import vSelect from 'vue-select';
import CrmSelector from '../../Common/Selectors/CrmSelector';
import moment from 'moment';
import BootstrapToggle from 'vue-bootstrap-toggle';
import UpdateAmount from "./UpdateAmount.vue";
import UpdateExpected from "./UpdateExpected";
import UpdateExpenses from "./UpdateExpenses.vue";
import DatePicker from 'vue2-datepicker';
import Editor from '../../Common/Quill';

export default {

    components: {
        Money,
        vSelect,
        CrmSelector,
        BootstrapToggle,
        UpdateAmount,
        UpdateExpected,
        UpdateExpenses,
        DatePicker,
        Editor,
    },

    computed: {
        ...mapGetters([
            'getAuth',
            "getCostcodes",
            "getMoneySettings",
            "getRoutes",
        ]),

        calcTargetBudget(){
            return (this.task.fee * 100) -
                this.getPurchaseInvoicesTotal -
                (this.task.reserved * 100);
        },

        canAddUsergroupRate() {
            return this.usergroupForm.rate > 0 &&
                this.usergroupForm.usergroup_id !== null &&
                this.canEditFinance === true;
        },

        canSavePurchaseInvoice(){
            return this.purchaseinvoice.amount !== 0 &&
                this.purchaseinvoice.expecteddate !== null &&
                this.canEditFinance === true;
        },

        canSaveSalesInvoice(){
            return this.salesinvoice.amount !== 0 &&
                this.salesinvoice.expecteddate !== null &&
                this.salesinvoice.paymentterm > 0 &&
                Object.keys(this.salesinvoice.contact).length > 0 &&
                this.canEditFinance === true;
        },

        canSubmit(){
            return this.canSubmitText &&
                this.task.enddate !== null &&
                this.task.startdate !== null &&
                this.task.tasktype !== '' &&
                this.submitting === false;
        },
        canSubmitText(){
            return (this.task.owntext === true && this.task.text !== "") || (this.task.owntext === false && this.task.tasktype !== null);
        },
        canSubmitType(){
            return (this.tasktypes.length > 0 && this.task.tasktype !== null) ||
                (this.tasktypes.length === 0 && this.task.text !== "");
        },

        getAvailableUsergroups() {
            let usergroups = [];
            this.usergroups.forEach(usergroup => {
                if (this.usergroupRates.findIndex(ur => ur.id === usergroup.id) === -1) {
                    usergroups.push(usergroup);
                }
            });
            return usergroups;
        },

        getNonSelectedCostcodes() {
            let selectedcc = [];
            this.selectedCostcodes.forEach(cc => { selectedcc.push(cc.id); });
            let costcodes = this.getCostcodes;
            return costcodes.filter(cc => {
                return !selectedcc.includes(cc.id);
            });
        },

        getPaymentTerm() {
            return this.getAuth.settings.financial.invoice.payment_term;
        },

        getPostData() {
            let task = JSON.parse(JSON.stringify(this.task));
            if (task.startdate !== null) {
                task.startdate = moment(task.startdate).format("YYYY-MM-DD");
            }
            if (task.enddate !== null) {
                task.enddate = moment(task.enddate).format("YYYY-MM-DD");
            }
            if (task.owntext !== true) {
                task.type_id = task.tasktype.value;
            }
            return task;
        },

        getPurchaseinvoiceContact(){
            if (!this.purchaseinvoice.contact || typeof this.purchaseinvoice.contact.company_name === "undefined") { return ""; }
            if (this.purchaseinvoice.contact.company_name === '') {
                return this.purchaseinvoice.contact.full_name;
            } else {
                return this.purchaseinvoice.contact.full_name + " (" + this.purchaseinvoice.contact.company_name + ")";
            }
        },

        getPurchaseInvoices() {
            return this.purchaseinvoices;
        },

        getPurchaseInvoicesTotal() {
            let total = 0;
            this.purchaseinvoices.forEach((pi) => {
                total += parseInt(pi.sub_total);
            });
            return total;
        },

        getSalesInvoiceRemaining() {
            return ((this.task.fee * 100) + (this.task.expenses * 100)) - this.getSalesInvoicesTotal;
        },

        getSalesInvoicesTotal() {
            let total = 0;
            this.salesinvoices.forEach((si) => {
                total += parseInt(si.sub_total);
            });
            return total;
        },

        getSalesinvoiceContact(){
            if (!this.salesinvoice.contact || typeof this.salesinvoice.contact.company_name === "undefined") { return ""; }
            if (this.salesinvoice.contact.company_name === '') {
                return this.salesinvoice.contact.full_name;
            } else {
                return this.salesinvoice.contact.full_name + " (" + this.salesinvoice.contact.company_name + ")";
            }
        },

        getUsergroupData() {
            let usergroups = JSON.parse(JSON.stringify(this.usergroups));
            usergroups.forEach(ug => ug.origrate = ug.rate);
            this.usergroupRates.forEach(ugr => {
                let index = usergroups.findIndex(ug => ugr.id === ug.id);
                usergroups[index].rate = ugr.rate;
                usergroups[index].paths = ugr.paths;
            });
            return usergroups;
        },

        postPurchaseInvoiceData() {
            return {
                task_uuid: this.task.uuid,
                amount: this.purchaseinvoice.amount,
                contact: this.purchaseinvoice.contact.uuid,
                description: this.purchaseinvoice.description,
                expenses: this.purchaseinvoice.expenses,
                expected_at: moment(this.purchaseinvoice.expecteddate).format("YYYY-MM-DD"),
            };
        },

        postSalesInvoiceData() {
            return {
                task_uuid: this.task.uuid,
                amount: this.salesinvoice.amount,
                contact: this.salesinvoice.contact.uuid,
                expenses: this.salesinvoice.expenses,
                expected_at: moment(this.salesinvoice.expecteddate).format("YYYY-MM-DD"),
                nrmonths: this.salesinvoice.nrmonths,
                paymentterm: this.salesinvoice.paymentterm,
                po_number: this.salesinvoice.po_number,
            };
        },

        postUsergroupRateData() {
            return {
                task_uuid: this.task.uuid,
                rate: !this.canAddUsergroupRate ? 0 : this.usergroupForm.rate,
                usergroup_id: !this.canAddUsergroupRate ? null : this.usergroupForm.usergroup_id.id,
            }
        },
    },

    data() {
        return {
            active:false,

            editing: false,
            edituri:'',

            lang:Lang,

            loadingtask:false,

            moment:moment,

            purchaseinvoice: {
                contact:{},
                description:'',
                expecteddate:null,
                amount:0,
                expenses:0,
            },
            purchaseinvoices:[],

            task: {
                active:false,
                costcodes:[],
                description:'',
                enddate:null,
                expenses:0,
                fee:0,
                reserved:0,
                parent_id:null,
                startdate:null,
                tasktype:null,
                paymentterm: this.getPaymentTerm,
                po_number:'',
                text:'',
                owntext:false,
            },

            tasktypes:[],

            salesinvoice: {
                contact:{},
                expecteddate:null,
                amount:0,
                expenses:0,
                paymentterm:0,
                nrmonths:1,
                po_number:'',
            },
            salesinvoices:[],

            section:null,

            selectedContactType:'',

            selectedCostcodes:[],
            selectedCostcode:null,

            submitting: false,

            usergroupForm:{
                usergroup_id:null,
                rate:0,
            },
            usergroupRates:[],
            usergroups:[],

        }
    },

    destroyed() {
        Hub.$off('open-task-add-modal', this.openTaskAddModal);
        Hub.$off('open-task-edit-modal', this.openTaskEditModal);
    },

    methods: {

        ...mapActions([
            "setCostcodes",
        ]),

        addUsergroupRate() {
            if (!this.canAddUsergroupRate) {
                return;
            }
            axios.post(this.route('api.v1.usergroups.add'), this.postUsergroupRateData)
            .then(() => {
                this.usergroupRates.push({
                    name: this.usergroupForm.usergroup_id.name,
                    id: this.usergroupForm.usergroup_id.id,
                    rate: this.usergroupForm.rate * 100,
                });
                this.usergroupForm = {
                    usergroup_id:null,
                    rate:0,
                };
                this.$snotify.success("Het afwijkende uurtarief is toegevoegd");
            })
        },

        closeSearch() {
            // Clear foritem again
            Hub.$emit("close-contact-selector");
        },

        closeTaskAddModal() {
            $('#taskFormModal').modal('hide');
        },

        deleteUsergroupRate(usergroupRate) {
            if (!this.canEditFinance) {
                return;
            }
            if (!confirm("Weet je zeker dat je het uurtarief wilt verwijderen?")) {
                return false;
            }
            axios.delete(usergroupRate.paths.delete)
            .then(() => {
                this.usergroupRates.splice(this.usergroupRates.findIndex(ur => ur.id === usergroupRate.id), 1);
                this.$snotify.success("Het afwijkende uurtarief is verwijderd");
            });
        },

        fetchCostcodes() {
            axios.get(this.route('api.v1.costcodes.project'))
            .then(response => {
                this.setCostcodes(response.data.data);
            });
        },

        fetchTaskInfo(task_id) {
            // Set loadingtask
            this.loadingtask = true;
            // Get the data
            axios.get(this.route('api.v1.tasks.single'), {params:{ task_uuid: task_id }})
            .then(response => {
                // Store task
                let task = response.data.data,
                    key;
                // Loop through the fields
                for (key in task) {
                    // Check if own property
                    if (task.hasOwnProperty(key)) {
                        // Check edituri
                        if (key === "edituri") {
                            this.edituri = task[key];
                        } else if (key === "type_id") {
                            // Check if null
                            if (task[key] === null) {
                                this.task.owntext = true;
                            } else {
                                // Get the record from the stored tasktypes
                                this.task.tasktype = this.tasktypes.filter(tt => tt.value === task[key])[0];
                                this.task.owntext = false;
                            }
                        } else if (key === "costcodes") {
                            this.selectedCostcodes = task[key];
                        } else if (key === "salesinvoices") {
                            this.salesinvoices = task[key];
                        } else if (key === "purchaseinvoices") {
                            this.purchaseinvoices = task[key];
                        } else if (key === "usergroupRates") {
                            this.usergroupRates = task[key];
                        } else if (key === 'startdate' || key === 'enddate') {
                            this.task[key] = moment(task[key]).toDate();
                        } else {
                            this.task[key] = task[key];
                        }
                    }
                }
                // Divide fee and expenses
                this.task.fee = this.task.fee / 100;
                this.task.expenses = this.task.expenses / 100;
                this.task.reserved = this.task.reserved / 100;
                // Store paymentterm
                this.salesinvoice.paymentterm = this.task.paymentterm;
                this.salesinvoice.po_number = this.task.po_number;
                // Reset loadingtask
                this.loadingtask = false;

                this.$refs.editor.setValue(this.task.description);
                // Open the modal
                $('#taskFormModal').modal('show');
            });
        },

        fetchTaskTypes() {
            axios.get(this.route('api.v1.categories.show') + '/ttask', {
                params: {
                    project_uuid: this.projectUuid
                }
            })
            .then(response => {
                let categories = response.data.data.categories;
                this.tasktypes = categories;
                if (categories.length === 0){
                    this.task.owntext = true;
                }
            });
        },

        fetchUsergroups() {
            axios.get(this.route('api.v1.usergroups.index'))
                .then(resp => this.usergroups = resp.data.data);
        },

        getInvoiceDeleteUri(invoice) {
            return this.route('api.v1.tasks.invoicedelete') + '?task_uuid=' + this.task.uuid + '&invoice_uuid=' + invoice.uuid;
        },

        onSubmit() {
            if (!this.canSubmit) {
                return false;
            }
            this.submitting = true;

            if (this.editing === true) {
                axios.post(this.edituri, this.getPostData)
                    .then(response => {
                        Hub.$emit("update-task-in-gantt-object", response.data.data.task);
                        this.closeTaskAddModal();
                        this.resetTaskObject();
                        this.$snotify.success("De taak is gewijzigd");
                    })
                    .catch(error => {
                        if (error.response && error.response.data.errors.global) {
                            this.$snotify.error(error.response.data.errors.global[0]);
                        } else {
                            this.$snotify.error("Er is een fout opgetreden bij het wijzigen van de taak.");
                        }
                    })
                    .finally(() => this.submitting = false);
            } else {
                // We're adding a task
                // Make sure all the fields are set.
                // Perform the post action
                axios.post(this.newTaskPostUri, this.getPostData)
                .then(response => {
                    // Check response
                    if (response.data.success) {
                        // Emit event
                        Hub.$emit('add-task-to-gantt-object',response.data.data.task);
                        // Close the window
                        this.closeTaskAddModal();
                        // Reset the task object
                        this.resetTaskObject();
                        // Set submitting
                        this.submitting = false;
                        // Show the flash message
                        this.$snotify.success("De taak is toegevoegd aan dit project en is direct in te zien in het onderstaande overzicht.");
                    } else {
                        // Something went wrong.
                        this.$snotify.error("Er is een fout opgetreden bij het toevoegen van de taak: " + response.data.errorMsg);
                        //todo
                    }
                });
            }
        },

        openTaskAddModal(parent_id) {
            this.task = {
                active:false,
                costcodes:[],
                description:'',
                enddate:null,
                expenses:0,
                fee:0,
                parent_id:parent_id,
                startdate:null,
                tasktype:null,
                paymentterm: this.getPaymentTerm,
                text:'',
                owntext:false,
            };
            if (this.tasktypes.length === 0) {
                this.task.owntext = true;
            }
            this.editing = false;
            $('#taskFormModal').modal('show');
        },

        openTaskEditModal(task_id) {
            // Set editing
            this.editing = true;
            // Get the data
            this.fetchTaskInfo(task_id);
        },

        removeCostcode(costcode) {
            this.selectedCostcodes = this.selectedCostcodes.filter(cc => {
                return cc.id !== costcode.id;
            });
        },

        resetSalesInvoiceForm() {
            this.salesinvoice = {
                contact:{},
                expecteddate:null,
                amount:0,
                expenses:0,
                paymentterm:0,
                nrmonths:1,
            };
        },

        resetTaskObject(){
            this.task = {
                active:false,
                costcodes:[],
                description:'',
                enddate:null,
                expenses:0,
                fee:0,
                parent_id:null,
                startdate:null,
                tasktype:null,
                paymentterm: this.getPaymentTerm,
                text:'',
                owntext:false,
            };
        },

        savePurchaseInvoice(){
            // Make sure we can actually save the purchase invoice
            if (!this.canEditFinance) {
                return;
            }
            // Ajax call
            axios.post(this.route('api.v1.tasks.purchaseinvoice'), this.postPurchaseInvoiceData)
            .then(response => {
                // add the object to the purchaseinvoices object
                this.purchaseinvoices.push(response.data.data);
                // Reset the values
                this.purchaseinvoice.amount = 0;
                this.purchaseinvoice.contact = {};
                this.purchaseinvoice.description = '';
                this.purchaseinvoice.expenses = 0;
                this.purchaseinvoice.expecteddate = null;
            });
        },

        saveSalesInvoice() {
            // Make sure we can actually save the sales invoice
            if (!this.canEditFinance) {
                return;
            }
            // Perform ajax call
            axios.post(this.route('api.v1.tasks.salesinvoice'), this.postSalesInvoiceData)
            .then(response => {
                // Check response data
                if (Array.isArray(response.data.data)) {
                    response.data.data.forEach(nr => this.salesinvoices.push(nr));
                } else {
                    // add the object to the salesinvoices object
                    this.salesinvoices.push(response.data.data);
                }
                // Reset the values
                this.resetSalesInvoiceForm();
                this.$snotify.success("De verkoopfactuur is toegevoegd");
            })
            .catch(() => {
                this.$snotify.error("Er is een fout opgetreden bij het toevoegen van de verkoopfactuur");
            })
        },

        adjustSubTotal (value, field, invoice) {
            invoice[field] = value;
            invoice.sub_total = invoice.amount + invoice.expenses;
        },

        searchContact(type){
            // Type is either invoice or purchase, for the different sections in the modal.
            this.selectedContactType = type;
            // Fire event to open the contact selector
            Hub.$emit("open-contact-selector");
        },

        selectContact(contact){
            // Add the contact to the proper property
            if (this.selectedContactType === "invoice") {
                this.salesinvoice.contact = contact;
            } else if (this.selectedContactType === "purchase") {
                this.purchaseinvoice.contact = contact;
            }
            // Reset selected contact type
            this.selectedContactType = "";
            // Close the search again.
            this.closeSearch();
        },

        setRequiredData(){
            this.fetchTaskTypes();
            this.fetchCostcodes();
            this.fetchUsergroups();
        },
    },

    mounted() {
        // Listen to specific event.
        this.$nextTick(function () {
            Hub.$on('open-task-add-modal', this.openTaskAddModal);
            Hub.$on('open-task-edit-modal', this.openTaskEditModal);
        }.bind(this));
        // Get the categories data required.
        this.setRequiredData();
    },

    name: "TasksFormModal",

    props: {

        canEditFinance: {
            type:Boolean,
            default:false,
        },

        newTaskPostUri: {
            type:String,
            required:true,
        },

        projectUuid: {
            type:String,
            default:"",
        },

    },
    watch: {
        selectedCostcode: function(newvalue) {
            // Make sure the new value is not null
            if (newvalue === null) {
                return;
            }
            // Add it to the selectedCostcodes variable
            this.selectedCostcodes.push(newvalue);
            // Set the value back to null, so the next one can be selected
            this.selectedCostcode = null;
        },
        selectedCostcodes: function(newvalue) {
            // Only patch if we're not loading a task
            if (this.loadingtask === false) {
                // Patch the task costcodes.
                axios.patch(this.route('api.v1.tasks.costcodes'), {task_uuid:this.task.uuid,costcodes:this.selectedCostcodes});
            }
        },
    }

}

</script>
